import _ from 'lodash';

export const getColorAlpha = (value = '') => {
	const rgbaValues = typeof value === 'string' ? value.match(/\d+/g) : null;

	return rgbaValues && rgbaValues.length === 4 ? _.last(rgbaValues) : '1';
};
